<template>
  <div class="goTop" v-if="scrollTopHigth > 100" @click="goTop">
    <img src="../../images/totop_arrow.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: "goTop",
  data() {
    return {
      showBtn: false,
      scrollTopHigth: 0,
    };
  },
  methods: {
    // goTop() {
    //   window.scrollTo(0, 0);
    // },
    goTop() {
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollAnimation(currentY, 0);
    },
    scrollAnimation(currentY, targetY) {
      // 获取当前位置方法
      // 计算需要移动的距离
      let needScrollTop = targetY - currentY;
      let _currentY = currentY;
      setTimeout(() => {
        // 一次调用滑动帧数，每次调用会不一样
        const dist = Math.ceil(needScrollTop / 10);
        _currentY += dist;
        window.scrollTo(_currentY, currentY);
        // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY);
        } else {
          window.scrollTo(_currentY, targetY);
        }
      }, 1);
    },
    listenerFunctions() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.scrollTopHigth = scrollTop;
    },
    /**
     * 函数节流
     * 触发事件立即执行，但在n秒内连续触发则不执行
     */
    throttle(fn, wait = 1000) {
      let timer;
      return function() {
        if (timer != null) return;
        let context = this;
        let args = arguments;
        fn.apply(context, args);
        timer = setTimeout(() => {
          timer = null;
        }, wait);
      };
    },
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunctions);
  },

  created() {},
  mounted() {
    this.listenerFunctions();
    // window.onscroll = () => {
    //   // console.log(document.body.scrollTop,document.documentElement.scrollTop)
    //   if (document.documentElement.scrollTop == 0) {
    //     this.showBtn = false;
    //   } else {
    //     this.showBtn = true;
    //   }
    // };
  },
};
</script>

<style lang="scss" scoped>
$cl_green: #50bbe5;
$cl_dark: #444444;

.goTop {
  position: fixed;
  bottom: 0.5rem;
  left: 50%;
  margin-left: 1.28rem;
  width: 0.4rem;
  height: 0.5rem;
  z-index: 2;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0.2rem;
  img {
    display: block;
    width: 0.18rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
